// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"715":"093d64eb","3416":"093d64eb","3445":"db3b6b64","3490":"18374220","4953":"482da9cb","5296":"199963a6","5676":"093d64eb","5960":"093d64eb","8186":"cf0ea569","9691":"7140e9fe"}[chunkId] + ".chunk.css";
};